import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!token) { setStatus("missing"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => { setStatus("ok"); refresh(); })
      .catch((e) => {
        if (e.response?.status === 400) setStatus("invalid");
        else setStatus("error");
      });
  }, [token, refresh]);

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-24 text-center" data-testid="verify-email-page">
      {status === "checking" && <><i className="fas fa-circle-notch fa-spin text-4xl text-[#FFBE00] mb-4"></i><h1 className="font-heading font-black text-3xl">Verifica in corso…</h1></>}
      {status === "ok" && <><i className="fas fa-circle-check text-5xl text-[#22C55E] mb-4"></i><h1 className="font-heading font-black text-3xl">Email verificata!</h1><p className="text-zinc-400 mt-3">Il tuo account è attivo.</p><Link to="/dashboard" className="inline-block mt-6 px-6 py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase text-sm">Vai alla dashboard</Link></>}
      {status === "invalid" && <><i className="fas fa-circle-xmark text-5xl text-red-500 mb-4"></i><h1 className="font-heading font-black text-3xl">Token non valido o scaduto</h1><Link to="/login" className="inline-block mt-6 px-6 py-3 rounded-md border border-zinc-700 text-sm uppercase">Torna al login</Link></>}
      {status === "missing" && <><h1 className="font-heading font-black text-3xl">Token mancante</h1></>}
      {status === "error" && <><h1 className="font-heading font-black text-3xl">Errore imprevisto</h1></>}
    </div>
  );
}
